import * as ACTIONS from 'constants/Actions'

export const displayContactModal = () => ({
   type: ACTIONS.DISPLAY_CONTACT_MODAL
});

export const removeContactModal = () => ({
    type: ACTIONS.REMOVE_CONTACT_MODAL
});